import type { NextResponse } from 'next/server';
import type { CookieSerializeOptions } from 'cookie';
import type { CookieAttributes } from 'js-cookie';
import type { ServerRequest } from './cookie';

import Cookies from 'js-cookie';

import { getCookieServer } from './cookie';

export const COUNTRY_COOKIE_NAME = 'LEAFWELL_COUNTRY';

export function getCookieParams(): CookieSerializeOptions {
  const expirationDate = new Date();

  expirationDate.setDate(expirationDate.getDate() + 365);

  return {
    expires: expirationDate,
    secure: process.env.NODE_ENV !== 'development',
  };
}

export function setCountryCookie(value: string): void {
  Cookies.set(
    COUNTRY_COOKIE_NAME,
    value,
    getCookieParams() as CookieAttributes,
  );
}

export function removeCountryCookie(): void {
  Cookies.remove(COUNTRY_COOKIE_NAME);
}

export function getCountryCookie(): string | undefined {
  return Cookies.get(COUNTRY_COOKIE_NAME);
}

export function getCountryCookieServer(req: ServerRequest): string {
  return getCookieServer(req, COUNTRY_COOKIE_NAME);
}

export function setCountryCookieServer(
  res: NextResponse,
  value: string,
): NextResponse {
  res.cookies.set(COUNTRY_COOKIE_NAME, value, getCookieParams());
  return res;
}
